<template>
  <v-card flat>
    <v-dialog
      max-width="1000px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="previewDialogOpened"
      @keydown.esc="
        previewDialogOpened = false;
        documentPreviewData = '';
        previewRotation = 0;
      "
    >
      <v-card v-if="selectedDocumentLink && previewType">
        <v-card-title class="title">
          <span class="text-truncate" style="max-width: 600px">{{
            getDocumentName(selectedDocumentLink)
          }}</span>

          <v-spacer />
          <v-tooltip bottom class="mr-1">
            <v-btn
              fab
              small
              flat
              class="white primary--text text-capitalize ma-0"
              @click="previewRotation += 90"
              slot="activator"
            >
              <v-icon size="25"> rotate_right </v-icon>
            </v-btn>
            <span>Rotate</span>
          </v-tooltip>
          <v-btn
            fab
            small
            flat
            class="white error--text text-capitalize ma-0 ml-1"
            @click="
              previewDialogOpened = false;
              documentPreviewData = '';
              previewRotation = 0;
            "
          >
            <v-icon size="25"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="documentPreviewData && previewLoaded">
          <preview-document
            :document-preview-data="documentPreviewData"
            :preview-type="previewType"
            :preview-rotation="previewRotation"
          />
        </v-card-text>
        <v-card-text v-else>
          <v-progress-circular
            indeterminate
            size="50"
            class="primary--text ma-5"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card-text>
      <v-layout>
        <v-text-field
          v-model="fileName"
          placeholder="Search"
          class="mt-0 default-input"
          solo
        />
        <v-btn
          outline
          class="primary--text text-capitalize mr-2 my-0"
          :loading="loading"
          @click="testSearch"
        >
          Search
        </v-btn>
      </v-layout>

      <template v-if="results && results.length">
        <h3>Files Found</h3>
        <ul>
          <li :key="file.path" v-for="file in results" style="text-align: left">
            <a @click.prevent.stop="previewDocument(file.name)">{{
              file.name
            }}</a>
          </li>
        </ul>
      </template>
      <template v-else-if="results && !results.length">
        <v-alert :value="true" outline color="primary" class="text-xs-left">
          No results match your search criteria
        </v-alert>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import API from '@/api';
import '@firebase/auth';
import PreviewDocument from '@/components/PreviewDocument';
import { supportedExtensionsForPreview } from '@/constants/variables';
import { mapGetters } from 'vuex';

export default {
  name: 'DocumentsSearch',
  components: {
    PreviewDocument,
  },
  props: {
    currentCompany: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      results: null,
      supportedExtensionsForPreview,
      loading: false,
      fileName: null,
      previewType: null,
      previewLoaded: false,
      documentPreviewData: null,
      selectedDocumentLink: null,
      currentPage: 1,
      previewRotation: 0,
      previewDialogOpened: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
  },
  methods: {
    getDocumentName(document) {
      return document.split('/')[document.split('/').length - 1];
    },
    endsWithAny(suffixes, string) {
      return suffixes.find(function(suffix) {
        return string.toLowerCase().endsWith(suffix);
      });
    },
    async previewDocument(documentLink) {
      this.previewType = '';
      this.previewLoaded = false;
      this.documentPreviewData = '';
      this.selectedDocumentLink = documentLink;
      this.previewRotation = 0;
      this.previewType = this.endsWithAny(
        this.supportedExtensionsForPreview,
        this.selectedDocumentLink,
      );

      if (this.previewType === 'pdf') {
        this.currentPage = 1;
        this.pdfLoaded = false;
      }

      this.previewDialogOpened = true;
      try {
        const response = await API.integration.downloadDocument({
          companyId: this.currentUser.default_company.id,
          link: this.currentCompany.upload_link.concat(
            '/',
            this.selectedDocumentLink,
          ),
        });

        if (response.data.document) {
          this.documentPreviewData = response.data.document.data.link;
        } else {
          console.log(response.data.error);
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem downloading the document.',
            errorToSend: response.data.error,
          });
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem downloading the document.',
          errorToSend: e,
        });
      } finally {
        this.previewLoaded = true;
      }
    },
    async testSearch(e) {
      e.preventDefault();
      this.loading = true;
      const searchString = this.fileName
        ? this.fileName.replaceAll('(', '\\(').replaceAll(')', '\\)')
        : '';

      const response = await API.advisor.searchDocs({
        search: searchString,
        basePath: this.currentCompany.name,
      });
      const results = response.data.filter(file => {
        return file.indexOf('.') > -1;
      });
      const userPath = this.currentCompany.name + '/';

      this.results = results.map(file => {
        const firmPath = file.slice(0, file.indexOf(userPath));
        let name = file.replaceAll(firmPath, '');
        name = name.replaceAll(userPath, '');
        return {
          name: name,
          path: file,
        };
      });
      this.loading = false;
    },
  },
};
</script>

<style lang="postcss" scoped>
.container {
  max-width: 1000px;
}
.settings__container {
  max-width: 700px;
}
.google-sign-in {
  cursor: pointer;
}
</style>
